//@vendor
const React = require('react');
const PropTypes = require('prop-types');
//@components
const CalculateQuota = require('components/mortgageRequest/mortgageRequestPreApproval/mortgageRequestCalculateQuota/calculateQuota');

class MortgageRequestPreApprovalStepOne extends React.Component {

    render() {
        const {
            communityList,
            formHandlers,
            immCollectives,
            immFlagBasedFeatures,
            immGlobalVariables,
            immMortgageRequest,
            setMaxHousingCost,
        } = this.props;
        return (
            <div className="mortgage-request-preapproval-step-one">
                <CalculateQuota
                    communityList={communityList}
                    formHandlers={formHandlers}
                    immCollectives={immCollectives}
                    immFlagBasedFeatures={immFlagBasedFeatures}
                    immGlobalVariables={immGlobalVariables}
                    immMortgageRequest={immMortgageRequest}
                    setMaxHousingCost={setMaxHousingCost}
                />
            </div>
        );
    }
}

MortgageRequestPreApprovalStepOne.propTypes = {
    immMortgageRequest: PropTypes.object.isRequired,
    formHandlers: PropTypes.object.isRequired,
    communityList: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    immCollectives: PropTypes.object.isRequired,
    setMaxHousingCost: PropTypes.func.isRequired,
}

module.exports = MortgageRequestPreApprovalStepOne;
